import React, { useState } from 'react';
import { string } from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Button, Input, Avatar } from '@fiverr-private/fit';
import { URI } from '@fiverr-private/futile';
import {
    keyPressListener,
    KEYS,
} from '@fiverr-private/variations_display/src/lib';
import { makersExperience } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import SCREEN_BREAKPOINTS from '../../../../shared/constants/screenBreakpoints';
import { getStartedUrl } from '../../../../shared/constants/urls';
import { sendBiEventWithPosition } from '../../../../shared/utils/sendBiEventWithPosition';
import { GET_STARTED_CTA_POSITIONS } from '../../../../shared/constants';
import { EVENT_TYPES } from '../../../../service/bigquery';
import { INTEGRATIONS_MAP } from '../../constants';
import {
    SCROLL_OPTIONS,
    FIRST_SECTION_SELECTOR,
    INNER_CLASSES,
} from '../constants';
import slidesConfig from './config';
import './style.scss';

const { reportGetStartedSubmitted } = makersExperience.integrationLandingPage;

const scrollToFirstSection = () => {
    const el = document.querySelector(FIRST_SECTION_SELECTOR);

    if (el) {
        el.scrollIntoView(SCROLL_OPTIONS);
    }
};

const slides = Object.values(slidesConfig).map((slide) => slide);

const IntroHeader = ({ integration }) => {
    const [brandName, setBrandName] = useState('');

    const showExamples = useMediaQuery({
        query: '(min-width: 600px)',
    });

    const onBrandNameChange = ({ target: { value } }) => setBrandName(value);
    const onBrandNameSubmit = () => {
        sendBiEventWithPosition(
            GET_STARTED_CTA_POSITIONS.TOP,
            EVENT_TYPES.GET_STARTED_BUYER_CLICKED
        );
        reportGetStartedSubmitted({
            elementPosition: GET_STARTED_CTA_POSITIONS.TOP,
            brandName: brandName.trim(),
        });

        window.location = new URI(getStartedUrl())
            .addParams({
                source: INTEGRATIONS_MAP[integration]?.APP_NAME,
                get_started_brand_name: brandName,
            })
            .toString();
    };

    const renderSlides = (slide) =>
        slide.map(({ images, seller, name }) => {
            const { username, profileImage } = seller;
            return (
                <div key={name} className={`${name}_slide intro-header-slide`}>
                    <picture>
                        <source
                            media={`(min-width: ${SCREEN_BREAKPOINTS.lg}px)`}
                            srcSet={images.lg}
                        />
                        <source
                            media={`(min-width: ${SCREEN_BREAKPOINTS.md}px)`}
                            srcSet={images.md}
                        />
                        <source
                            media={`(min-width: ${SCREEN_BREAKPOINTS.sm}px)`}
                            srcSet={images.sm}
                        />
                        <img
                            src={images.md}
                            alt={translate(
                                'makers_experience_perseus.general.logo_maker_example'
                            )}
                        />
                    </picture>
                    <div className="seller-wrapper">
                        <span>
                            <I18n k="makers_experience_perseus.buyer_landing_page.header.author_label" />
                        </span>
                        <Avatar
                            className="intro-header-avatar"
                            src={profileImage}
                            username={username}
                        />
                        {username}
                    </div>
                </div>
            );
        });

    return (
        <div className="intro-header-container hero-section">
            <div className="intro-header-background"></div>
            <div className="intro-header-background"></div>
            <div className="intro-header-background"></div>

            <div className={INNER_CLASSES}>
                <div className="upper">
                    <div className="content-wrapper">
                        <div className="intro-header-content start-brief">
                            <h1>
                                <I18n
                                    k={INTEGRATIONS_MAP[integration].HERO_TITLE}
                                />
                            </h1>
                            <Input
                                inputClassName="intro-header-input"
                                placeholder={translate(
                                    'makers_experience_perseus.integration_landing_page.header.input_placeholder'
                                )}
                                name="get_started_brand_name"
                                autoComplete="off"
                                onChange={onBrandNameChange}
                                onKeyPress={keyPressListener({
                                    [KEYS.ENTER]: onBrandNameSubmit,
                                })}
                                aria-label={translate(
                                    'makers_experience_perseus.integration_landing_page.header.input_placeholder'
                                )}
                                data-lpignore="true"
                            />
                            <Button
                                className="intro-header-btn"
                                color={Button.COLORS.BLUE}
                                fill={Button.FILLS.GHOST}
                                onClick={onBrandNameSubmit}
                            >
                                <I18n k="makers_experience_perseus.general.make_your_logo" />
                            </Button>
                        </div>
                    </div>

                    {showExamples && (
                        <div className="image-wrapper">
                            {renderSlides(slides)}
                        </div>
                    )}
                </div>

                <button
                    className="scroll-arrow"
                    aria-label="Scroll down"
                    onClick={scrollToFirstSection}
                />
            </div>
        </div>
    );
};

IntroHeader.propTypes = {
    integration: string,
};

export default IntroHeader;
